// extracted by mini-css-extract-plugin
export var box = "_19-2";
export var checkboxControl = "_19-0";
export var checkboxRow = "_19-a";
export var checked = "_19-3";
export var descriptionSpacer = "_19-c";
export var disabled = "_19-4";
export var icon = "_19-8";
export var input = "_19-1";
export var labelSpacer = "_19-b";
export var large = "_19-7";
export var medium = "_19-6";
export var small = "_19-5";
export var text = "_19-9";